import { AddIcon } from '@approvalmax/ui';
import { Button, Flex } from '@approvalmax/ui/src/components';
import { useSetAtom } from 'jotai';
import { domain } from 'modules/data';
import { FC, memo, useCallback } from 'react';
import { HelpStripe } from 'shared/components';

import { useIsInRoles } from '../../hooks/useIsInRoles';
import { useReadOnlyCompany } from '../../hooks/useReadOnlyCompany';
import { connectBankAccountPopupOpenState } from '../ConnectBankAccountPopup/ConnectBankAccountPopup.states';
import { messages } from './Toolbar.messages';
import { ToolbarProps } from './Toolbar.types';

export const Toolbar: FC<ToolbarProps> = memo((props) => {
    const { helpItemId } = props;

    const setNewBankAccountOpen = useSetAtom(connectBankAccountPopupOpenState);
    const isReadOnly = useReadOnlyCompany();
    const isAuditor = useIsInRoles(domain.CompanyUserRole.Auditor);

    const handleNewBankAccountPopupOpen = useCallback(() => {
        setNewBankAccountOpen(true);
    }, [setNewBankAccountOpen]);

    return (
        <Flex justifyContent='space-between'>
            {!isAuditor ? (
                <Button
                    color='blue10'
                    size='small'
                    disabled={isReadOnly}
                    startIcon={<AddIcon />}
                    onClick={handleNewBankAccountPopupOpen}
                >
                    {messages.newBankAccount}
                </Button>
            ) : (
                <div />
            )}

            <Flex spacing='16'>
                <HelpStripe.ToggleButton id={helpItemId} />
            </Flex>
        </Flex>
    );
});
